module.exports = __webpack_public_path__ + "static/media/63_tn.49956929.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/63_tn.jpg
// module id = 550
// module chunks = 0